// extracted by mini-css-extract-plugin
export var checkbox = "_2n-0";
export var circle = "_2n-3";
export var horizontalContainer = "_2n-7";
export var sm = "_2n-5";
export var switch0 = "_2n-2";
export var switchDisabled = "_2n-8";
export var switchEnabled = "_2n-1";
export var textSwitchContainer = "_2n-9";
export var textSwitchOption = "_2n-a";
export var textSwitchOptionSelected = "_2n-b";
export var verticalContainer = "_2n-6";
export var xs = "_2n-4";